import { render, staticRenderFns } from "./parts-replace-dialog.vue?vue&type=template&id=9b4d9f50&"
import script from "./parts-replace-dialog.vue?vue&type=script&lang=ts&"
export * from "./parts-replace-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./parts-replace-dialog.vue?vue&type=style&index=0&id=9b4d9f50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports